import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=04580484&scoped=true"
var script = {}
import style0 from "./Project.vue?vue&type=style&index=0&id=04580484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04580484",
  null
  
)

export default component.exports